import React, { useEffect, useState } from "react";
import * as global from "../data/global";
import { ModalChrome, SITE_WINDOW_IDS, SiteSelectPhase, ALL_SITES_OPTION } from "./windowChrome/index.js";

const SiteFilter = ({ isModalOpen, setIsModalOpen }) => {
    const [pickerValue, setPickerValue] = useState("");

    useEffect(() => {
        if (!isModalOpen[0]) setPickerValue("");
    }, [isModalOpen]);

    const handleClose = () => setIsModalOpen([false]);

    const adjustScroll = (element) => {
        element.scrollIntoView({ behavior: "instant", block: "center" });
        window.scrollTo(0, -10);
        window.scrollTo(0, 100);
    };

    const applyFilter = (value) => {
        const siteCards = document.getElementsByClassName("siteCard");
        for (let i = 0; i < siteCards.length; i++) {
            if (value == 0) {
                siteCards[i].style.display = "block";
                if (i === 0) adjustScroll(siteCards[i]);
            } else if (siteCards[i].getAttribute("siteid") == value) {
                siteCards[i].style.display = "block";
                adjustScroll(siteCards[i]);
            } else {
                siteCards[i].style.display = "none";
            }
        }
        global.gw.siteFilter = value;
        handleClose();
    };

    return (
        <ModalChrome
            open={isModalOpen[0]}
            onClose={handleClose}
            title="Filter"
            toolTitle="Filter"
            siteWindowId={SITE_WINDOW_IDS.filter}
            className="siteFilterModal hide-scrollbar"
        >
            <SiteSelectPhase
                value={pickerValue}
                onChange={setPickerValue}
                includeAllSites
                allSitesLabel="All"
                onContinue={(guid) => {
                    applyFilter(guid === ALL_SITES_OPTION ? 0 : guid);
                }}
                onCancel={handleClose}
            />
        </ModalChrome>
    );
};

export default SiteFilter;
